// Per-user "smart defaults": remembered choices + time-aware suggestions, stored in the browser only.
const KEY = "kt_smart_prefs";

const readAll = () => { try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; } };

export const recall = (userId, field) => readAll()?.[userId || "anon"]?.[field] ?? null;
export const remember = (userId, field, value) => {
  const all = readAll();
  const u = userId || "anon";
  all[u] = { ...(all[u] || {}), [field]: value };
  localStorage.setItem(KEY, JSON.stringify(all));
};

export const withIndiaPrefix = (v) => {
  const s = String(v || "");
  if (!s || s.startsWith("+") || /[a-zA-Z@]/.test(s)) return s;
  const digits = s.replace(/\D/g, "");
  if (!digits) return s;
  return `+91 ${digits.startsWith("91") && digits.length > 10 ? digits.slice(2) : digits}`;
};

// Live formatter for the Indian phone field: keeps the "+91 " prefix fixed, strips
// non-digits, drops the country code / any leading zero, and caps the subscriber part at 10 digits.
export const formatIndiaPhoneInput = (v) => {
  let digits = String(v || "").replace(/\D/g, "");
  if (digits.startsWith("91")) digits = digits.slice(2);
  digits = digits.replace(/^0+/, "").slice(0, 10);
  return `+91 ${digits}`;
};
export const indiaPhoneDigits = (v) => formatIndiaPhoneInput(v).replace("+91 ", "");
export const isValidIndiaPhone = (v) => /^\d{10}$/.test(indiaPhoneDigits(v));

// Round up to the next 15-minute slot at least `minAheadMin` minutes from now.
export const nextSlot = (minAheadMin = 30) => {
  const d = new Date(Date.now() + minAheadMin * 60000);
  d.setSeconds(0, 0);
  d.setMinutes(Math.ceil(d.getMinutes() / 15) * 15);
  return d;
};
export const toLocalInput = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);

export const scheduleChips = () => {
  const inHour = new Date(Date.now() + 3600 * 1000); inHour.setSeconds(0, 0); inHour.setMinutes(Math.ceil(inHour.getMinutes() / 15) * 15);
  const tmrw = (h) => { const d = new Date(); d.setDate(d.getDate() + 1); d.setHours(h, 0, 0, 0); return d; };
  return [
    { id: "next", label: "Next slot", value: toLocalInput(nextSlot()) },
    { id: "1h", label: "In 1 hr", value: toLocalInput(inHour) },
    { id: "tm8", label: "Tomorrow 8:00 AM", value: toLocalInput(tmrw(8)) },
    { id: "tm18", label: "Tomorrow 6:00 PM", value: toLocalInput(tmrw(18)) },
  ];
};

export const MEALS = [
  { id: "breakfast", label: "Breakfast", greeting: "Good morning", match: /cafe|south indian|healthy|bakery|tea|breakfast|coffee/i },
  { id: "lunch", label: "Lunch", greeting: "Good afternoon", match: /biryani|indian|naga|thali|chinese|healthy|rice|meals|kitchen/i },
  { id: "snacks", label: "Snacks", greeting: "Good afternoon", match: /cafe|fast|momo|street|bakery|snack|roll|tea|coffee/i },
  { id: "dinner", label: "Dinner", greeting: "Good evening", match: /naga|chinese|italian|pizza|biryani|indian|wok|grill|kitchen/i },
  { id: "latenight", label: "Late-night", greeting: "Late night", match: /pizza|chinese|fast|momo|biryani|wok|roll/i },
];

export const currentMeal = (h = new Date().getHours()) =>
  h < 5 ? MEALS[4] : h < 11 ? MEALS[0] : h < 15 ? MEALS[1] : h < 18 ? MEALS[2] : h < 22 ? MEALS[3] : MEALS[4];

export const BUDGETS = [
  { id: "all", label: "Any budget", test: () => true },
  { id: "lt150", label: "Under ₹150", test: (r) => (r.min_order || 0) < 150 },
  { id: "150-300", label: "₹150–300", test: (r) => (r.min_order || 0) >= 150 && (r.min_order || 0) <= 300 },
  { id: "gt300", label: "₹300+", test: (r) => (r.min_order || 0) > 300 },
];

export const PAY_METHODS = ["cash", "upi", "card"];
